import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { brand, featuredReview, reviews } from '../data/site';
const EASE = [0.23, 1, 0.32, 1] as const;
const all = [featuredReview, ...reviews];
function Stars({
  tone = 'clay'
}: {
  tone?: 'clay' | 'cream';
}) {
  return <div className="flex gap-0.5" aria-hidden="true" data-id="element-93" data-mp="2rb1w1cxym03o">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${tone === 'clay' ? 'fill-clay text-clay' : 'fill-cream text-cream'}`} data-id="element-94" data-mp="2wao6jemel28s" data-mpi={i} />)}
    </div>;
}
export function Reviews() {
  return <section className="bg-paper px-6 py-20 lg:py-24" data-id="element-95" data-mp="353hs1tsg0xv3">
      <div className="mx-auto max-w-6xl" data-id="element-96" data-mp="3a19sjc75lsaw">
        <div className="flex flex-wrap items-end justify-between gap-8" data-id="element-97" data-mp="39zyfsmvqda7n">
          <div data-id="element-98" data-mp="3f0w65mqw9ak8">
            <p className="text-sm text-clay" data-id="element-99" data-mp="3f1fdk9ix4gk0">Reviews</p>
            <h2 className="mt-4 text-[clamp(1.9rem,3.6vw,3rem)] font-semibold leading-[1.08] tracking-[-0.03em] text-ink" data-id="element-100" data-mp="3jzgx0vk9ahw0">
              Wat gasten zeggen
            </h2>
          </div>
          <div className="flex items-center gap-4 rounded-2xl border border-ink/10 bg-cream px-5 py-4" data-id="element-101" data-mp="2raktedub3za6">
            <span className="text-3xl font-semibold tracking-[-0.02em] text-ink" data-id="element-102" data-mp="2mfx9yte5tv2g">
              {brand.rating}
            </span>
            <span data-id="element-103" data-mp="2dde8acm41ohs">
              <Stars data-id="element-104" data-mp="2ddxtc2724t01" />
              <span className="mt-1 block text-sm text-mist" data-id="element-105" data-mp="2depdmgv7f4b0">
                {brand.reviewCount} Google reviews
              </span>
            </span>
          </div>
        </div>

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-106" data-mp="355ddzqp205nm">
          {all.map((review, i) => <motion.li key={review.name} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-10%'
        }} transition={{
          duration: 0.25,
          ease: EASE,
          delay: i % 4 * 0.05
        }} className="flex flex-col rounded-2xl border border-ink/10 bg-cream p-6" data-id="element-107" data-mp="30bspqqd9iq1m" data-mpi={i}>
              <Stars data-id="element-108" data-mp="1m6p6gqclr91v" />
              <p className="mt-4 text-base leading-relaxed text-ink/80" data-id="element-109" data-mp="1m65ya1cr7z11">{review.quote}</p>
              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-110" data-mp="1r3xomqxr3d34">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-sand text-sm font-medium text-ink" data-id="element-111" data-mp="1cejhlphnd7qw">
                  {review.name.charAt(0)}
                </span>
                <span className="text-sm font-medium text-ink" data-id="element-112" data-mp="13emys4hxv33r">{review.name}</span>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}